/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';

export interface PatientArchiveRestore$Params {
  restoreBy?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  restoreFlag?: string | null;
  patientArchiveId?: number;
  patientId?: string | null;
}

export function patientArchiveRestore(http: HttpClient, rootUrl: string, params?: PatientArchiveRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, patientArchiveRestore.PATH, 'post');
  if (params) {
    rb.query('restoreBy', params.restoreBy, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('restoreFlag', params.restoreFlag, {});
    rb.query('patientArchiveId', params.patientArchiveId, {});
    rb.query('patientId', params.patientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

patientArchiveRestore.PATH = '/api/PatientArchive/patientarchive/restore';
